import React from "react";
import { Fit, Layout, useRive } from "@rive-app/react-canvas";
import Load from "../../../assets/images/Loader.riv";

const Loader = ({ admin = false }) => {
  const { RiveComponent } = useRive({
    src: Load,
    layout: new Layout({
      fit: Fit.Contain,
      alignment: Fit.Center,
    }),
    autoplay: true,
  });

  return (
    <div style={{ top: admin && "76%" }} className="loader-container">
      <RiveComponent className="rive-loader" />
    </div>
  );
};

export default Loader;
